import { ActionBrick, registerBrick, GlobalProperties } from 'olympe';
import { getLogger } from '@olympeio/core';
import { isMatomoTrackingEnabled, isMatomoTrackingInserted } from './helper';

export default class MatomoTrackSomething extends ActionBrick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} methodName
     * @param {ListDef} parameters
     * @param {function()} forwardEvent
     */
    update($, [methodName, parameters], [forwardEvent]) {
        const logger = getLogger(`Matomo`);

        if ($.get(GlobalProperties.EDITION, true)) {
            logger.debug('Ignoring tracking in EDITION mode.');
            forwardEvent();
            return;
        }

        if (typeof methodName !== 'string' || methodName.length === 0) {
            logger.error('Invalid input, methodName is required and must be string. Ignoring tracking.');
            forwardEvent();
            return;
        }

        logger.debug(`Push "${methodName}" track instruction with the following parameters: ${parameters.map(x => typeof x === 'object' ? JSON.stringify(x) : x).join(', ')}`);

        if (!isMatomoTrackingEnabled($)) {
            // silentely ignore tracking instruction as Matomo is disabled
            forwardEvent();
            return;
        }

        if (!isMatomoTrackingInserted()) {
            logger.warn('Tracking code is missing, you probably need to add the `[Matomo] InsertTrackingCode` brick before calling this action.');
            forwardEvent();
            return;
        }

        const _paq = window._paq || [];
        _paq.push([methodName, ...parameters]);
        forwardEvent();
    }
}

registerBrick('018804dcd51d722c070d', MatomoTrackSomething);
